import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CardConfig } from '../../models/mobile-table';
import { getVar } from '../../Utils/css';
import { TableEvent } from '../table/Itable';
import { CurrencySymbolPipe } from '../../Utils/currency-simbol-pipe';
;


@Component({
  selector: 'app-mobile-card-list',
  templateUrl: './mobile-card-list.component.html',
  styleUrls: ['./mobile-card-list.component.scss']
})
export class MobileCardListComponent {
  @Input() data: any[] = [];
  @Input() config!: CardConfig;
  @Input() showNoData: boolean = false;
  @Output() cardAction = new EventEmitter<any>();
  @Output() action: EventEmitter<TableEvent> = new EventEmitter<TableEvent>();

  showMenuForItem: any = null;

  menuColor = getVar('--global-secondary-color');

  constructor(
    private currencySymbolPipe: CurrencySymbolPipe
  ) {}

  toggleMenu(item: any): void {
    this.showMenuForItem = this.showMenuForItem === item ? null : item;
  }

  onCardAction(item: any, action: string): void {
    this.showMenuForItem = null; 
    if (this.config?.actions && this.config.actions.length > 1) {
      this.cardAction.emit({ item, action });
      this.action.emit({ event: action, dataField: item });
    } else {
      this.cardAction.emit(item);
    }
  }

  getCurrencySymbol(currencyCode: string): string {
    return this.currencySymbolPipe.transform(currencyCode);
  }
}
export { CardConfig };

